import React from 'react';
import '../styles/Footer.scss';

const Footer = () => (
  <div className="credit">
    created by
    <span> Techie Emma </span>
    all rights reserved!
  </div>
);

export default Footer;
